import { render, staticRenderFns } from "./CreateReferralLink.vue?vue&type=template&id=a6be1546&scoped=true"
import script from "./CreateReferralLink.vue?vue&type=script&lang=js"
export * from "./CreateReferralLink.vue?vue&type=script&lang=js"
import style0 from "./CreateReferralLink.vue?vue&type=style&index=0&id=a6be1546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6be1546",
  null
  
)

export default component.exports